<ems-confirm-message #confirmationMessage></ems-confirm-message>

<div class="heading-font sdps-p-bottom_small sdps-display-inline"
     [innerHTML]="getConstant.manageEmployeeGroups.empGroupStep3.reviewAndSave"></div>

<!-- Group Name and Description -->
<ems-accordion label={{getSharedConstant[businessUnit].nameAndDescription}} [editable]="showActionItems && !sharedService.showHistoricalView.value"
               class="disabled-button-icon" [disabledButton]="true" [toolTip]="true" [message]="toolTipMessage">
  <div class="sdps-p-around_large select-rule-type">
    <form [formGroup]="reviewEmpGrpRuleForm">
      <div class="sdps-grid-container sdps-wrap sdps-m-around_none">
        <div class="sdps-row">
          <div class="rule-type-textbox col-3"
               [ngClass]="{'invalidField': ((reviewEmpGrpRuleForm.get('groupName').value && (reviewEmpGrpRuleForm.get('groupName').invalid)|| groupNameExists)), 'input-disabled': (!showActionItems || sharedService.showHistoricalView.value)}">
            <p-floatlabel variant="in">
              <input *ngIf= "this.businessUnit === 'DBS' || this.businessUnit === 'SPS'" #focusName type="text" name="groupName" id="step3GroupNameInput" [maxlength]=100 formControlName="groupName"
                     (ngModelChange)="editGroupNameAndDescription()" emsAlphaNumericSpecialCharacterValidation
                     pInputText/>
              <input *ngIf= "this.businessUnit === 'RBS' || this.businessUnit===this.getSharedConstant.manageMasterGroups.groupTypeMGP" id="step3PlanNameInput" #focusName type="text" name="groupName" [maxlength]=100 formControlName="groupName"
                     (ngModelChange)="editGroupNameAndDescription()"
                     pInputText/>
              <label [for]="(this.businessUnit === 'DBS' || this.businessUnit === 'SPS') ? 'step3GroupNameInput' : 'step3PlanNameInput'">{{getSharedConstant[businessUnit].name}}
                <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
              </label>
            </p-floatlabel>
          </div>
          @if(this.businessUnit===this.getSharedConstant.manageMasterGroups.groupTypeMGP && (manageEmpGrpService.showOBPCheckbox || this.formDataService.getFormData()?.subType === this.getSharedConstant.openBrokerage.subType)) {
          <div class="col-6 sdps-p-left_xx-large sdps-flex">
            <div class="sdps-p-top_medium">
              <p-checkbox class="emtr-checkbox" inputId="reviewOpenBrokeragePlan" formControlName="openBrokeragePlan" 
               (ngModelChange)="editGroupNameAndDescription()"
                [ngClass]="{'p-disabled': isEditMode}" binary="true"></p-checkbox>
              <label for="reviewOpenBrokeragePlan" [ngClass]="{'labelDisabled': isEditMode || reviewRuleGroupData.toEnableOpenBrokeragePlan}" class="sdps-p-left_small">{{getSharedConstant.openBrokerage.openBrokeragePlanLbl}}</label>
            </div>
          </div>
          }
          <div class="col-9 sdps-p-left_xx-large sdps-flex" *ngIf="is10b5Client">
            <div class="sdps-p-top_medium">
              <p-checkbox class="emtr-checkbox" inputId="reviewEnable10b5Checkbox" formControlName="enable10b5Checkbox"
                          (onChange)="validate10b5()" (ngModelChange)="editGroupNameAndDescription()"
                          [disabled]="isEditMode" binary="true"></p-checkbox>
                          <label for="reviewEnable10b5Checkbox" class="sdps-p-left_small">10b5-1</label>
            </div>
            <div class="sdps-display-inline-block sdps-m-left_xx-large"
                 [ngClass]="{'invalidField': (reviewEmpGrpRuleForm.get('planId').value && reviewEmpGrpRuleForm.get('planId').invalid), 'input-disabled': isEditMode}"
                 *ngIf="reviewEmpGrpRuleForm.get('enable10b5Checkbox').value">
              <p-floatlabel variant="in">
                <input type="number" onkeypress="return (event.which >= 48 && event.which <= 57 && this.value.length < 10)" [disabled]="isEditMode" name="planId" formControlName="planId"
                       (ngModelChange)="editGroupNameAndDescription()" (blur)="removeLeadingZeroes()" emsNumberPatterncheck pTextarea id="in_label"/>
                <label for="in_label">{{getConstant.manageEmployeeGroups.empGroup10b5Msg.planIdTxt}}
                  <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
                </label>
              </p-floatlabel>
            </div>
          </div>
        </div>
        <p class="col-3 sdps-text-right sdps-p-around_none sdps-m-around_none sdps-text-small"
           *ngIf="reviewEmpGrpRuleForm.get('groupName').value && reviewEmpGrpRuleForm.get('groupName').value.trim().length>90">{{getConstant.rulesConstant.characterLimit}}
          <span class="character-limit">{{reviewEmpGrpRuleForm.get('groupName').value.trim().length}}/100</span>
        </p>

        <div class="sdps-row sdps-p-top_large">
          <div class="rule-type-textbox sdps-p-around_medium col-6" [ngClass]="{'input-disabled': (!showActionItems || sharedService.showHistoricalView.value)}">
            <p-floatlabel variant="in">
              <textarea id="reviewGroupDescription" class="sdps-p-vertical_x-small" rows="5" maxlength="300" formControlName="description"
                        (ngModelChange)="editGroupNameAndDescription()" pTextarea></textarea>
              <label for="reviewGroupDescription" *ngIf="showActionItems">{{getSharedConstant[businessUnit].description}}</label>
            </p-floatlabel>
          </div>
        </div>
        <p class="col-6 sdps-text-right sdps-p-around_none sdps-m-around_none sdps-text-small"
           *ngIf="reviewEmpGrpRuleForm.get('description').value && reviewEmpGrpRuleForm.get('description').value.length > 270">{{getConstant.rulesConstant.characterLimit}}
          <span class="character-limit">{{reviewEmpGrpRuleForm.get('description').value.length}}/300</span>
        </p>
      </div>
    </form>
  </div>
</ems-accordion>

<!-- Added/Removed employees/participants -->
<ems-accordion *ngIf="showEmployeePanel && this.sharedService.groupType !== this.getSharedConstant.manageMasterGroups.groupTypeMGP" [label]="getSharedConstant[businessUnit].employeeOrParticipantAddedOrRemoved"
               [editable]="showActionItems" (editPanel)="goToPreviousStep('../step2')">
  <ems-table-record-count [count]="" [showRecords]="showUpdatedData && showUpdatedData.length && showUpdatedData.length > getSharedConstant.defaultTableRecords" (emitter)="empPanel.reset();receiveDataFromChildPanel($event)"
                          [selectedCount]="" [empIds]="" [showHeaderIcons]="false"></ems-table-record-count>
  <p-table #empPanel [columns]="cols" [value]="showUpdatedData" [paginator]="(showUpdatedData && showUpdatedData.length && showUpdatedData.length > getSharedConstant.defaultTableRecords) ? true : false" [rows]="noOfRecordsPanel"
               [totalRecords]="showUpdatedData && showUpdatedData.length" class="common-data-table" sortField="empId" [sortOrder]="-1">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col" *ngFor="let col of columns"><span [innerHTML]="col.header"></span></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body"  let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns; let i = index">
          <!--<span
             *ngIf="i === 0 && businessUnit !=='RBS' && (rowNode.parent.children[0] === rowNode.node) && rowNode.parent.data[col.field] !== 0 && (rowNode.parent.data[col.field].indexOf('null') === -1)">{{rowNode.parent.data[col.field]}}</span> -->
          <span
            *ngIf="i === 0 && businessUnit !=='RBS' && rowData[col.field]">{{rowData[col.field]}}</span>
          <span *ngIf="(i === 0 && businessUnit === 'RBS') || (i === 1 && businessUnit !=='RBS')"
                [ngClass]="rowData.selectedEmployee === true ? 'addedEmp' : 'removedEmp'">{{rowData[col.field] | accountNumberFormat}}</span>
          <span *ngIf="col.field === 'firstName' || col.field === 'lastName'">{{rowData[col.field]}}</span>
          <span *ngIf="col.field === 'acctHolderName'">{{rowData['acctHolderLN']}} {{rowData['acctHolderFN']}}</span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="businessUnit === 'RBS' ? 4 : 5" class="sdps-text-center sdps-font-weight-bold" [innerHTML]="getSharedConstant.noRecords"></td>
      </tr>
    </ng-template>
  </p-table>
</ems-accordion>

<!-- Selected employees/participants - Edit flow when no changes is made to employees/participants selection -->
<ems-accordion *ngIf="!showEmployeePanel && reviewRuleGroupData.mode === 'EDIT' && this.sharedService.groupType !== this.getSharedConstant.manageMasterGroups.groupTypeMGP " [editable]="showActionItems && !sharedService.showHistoricalView.value"
               [label]="getSharedConstant[businessUnit].employeeOrParticipant"
               (editPanel)="goToPreviousStep('../step2')">
  <ems-table-record-count [count]="" [showRecords]="verifyData && verifyData.length && verifyData.length > 15" (emitter)="dtt.reset();receiveDataFromChild($event)" [selectedCount]="" [empIds]=""
                          [showHeaderIcons]="false"></ems-table-record-count>
  <p-table #dtt [columns]="cols" [value]="verifyData" [paginator]="(!isEditMode && verifyData && verifyData.length && verifyData.length >  getSharedConstant.defaultTableRecords) ? true : false" [rows]="noOfRecordsPanel"
    [totalRecords]="verifyData && verifyData.length" class="common-data-table" sortField="empId"
    [sortOrder]="-1">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col" *ngFor="let col of columns"><span [innerHTML]="col.header"></span></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns; let i = index">
          <span *ngIf="i === 0 && businessUnit !=='RBS' && rowData[col.field]">{{rowData[col.field]}}</span>
          <span *ngIf="(i === 0 && businessUnit === 'RBS') || (i === 1 && businessUnit !=='RBS')">{{rowData[col.field] | accountNumberFormat}}</span>
          <span *ngIf="col.field === 'firstName' || col.field === 'lastName'">{{rowData[col.field]}}</span>
          <span *ngIf="col.field === 'acctHolderName'">{{rowData['acctHolderLN']}} {{rowData['acctHolderFN']}}</span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="businessUnit === 'RBS' ? 4 : 5" class="sdps-text-center sdps-font-weight-bold" [innerHTML]="getSharedConstant.noRecords"></td>
      </tr>
    </ng-template>
  </p-table>
  <p-paginator #p *ngIf="isEditMode" [alwaysShow]="(isEditMode && totalRecords && totalRecords >  getSharedConstant.defaultTableRecords) ? true : false" [rows]="pageObject.pageSize" [totalRecords]="totalRecords"
               (onPageChange)="paginate($event)" class="common-pagination"></p-paginator>
</ems-accordion>

<!-- Added/Removed Master accounts - Manage master group -->
<ems-accordion *ngIf="showEmployeePanel && this.sharedService.groupType === this.getSharedConstant.manageMasterGroups.groupTypeMGP"
               [label]="getSharedConstant[businessUnit].employeeOrParticipantAddedOrRemoved" [editable]="showActionItems"
               (editPanel)="goToPreviousStep('../step2')">
  <ems-table-record-count [count]="" [showRecords]="addedOrRemoveMasterAcctList && addedOrRemoveMasterAcctList.length && addedOrRemoveMasterAcctList.length >  getSharedConstant.defaultTableRecords" (emitter)="mstrAcct.reset();receiveDataFromChildPanel($event)" [selectedCount]="" [empIds]=""
                          [showHeaderIcons]="false" [showExportBtn]="false" (exportClicked)="exportMasterGroup()"></ems-table-record-count>

  <p-table #mstrAcct [value]="addedOrRemoveMasterAcctList" [columns]="cols" [rows]="noOfRecordsPanel" [paginator]="(addedOrRemoveMasterAcctList && addedOrRemoveMasterAcctList.length && addedOrRemoveMasterAcctList.length >  getSharedConstant.defaultTableRecords) ? true : false"
    [totalRecords]="addedOrRemoveMasterAcctList && addedOrRemoveMasterAcctList.length" class="common-data-table">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col" *ngFor="let col of columns"><span [innerHTML]="col.header"></span></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns">
          <span *ngIf="col.field === 'firstName'">{{rowData[col.field]}}</span>
          <span *ngIf="col.field === 'subAcctNum'"
                [ngClass]="rowData['selectedAcct'] === true ? 'addedEmp' : 'removedEmp'">{{rowData[col.field]}}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</ems-accordion>

<!-- Selected Master accounts - Edit flow when no changes is made to master accounts selection - Manage master group -->
<ems-accordion *ngIf="!showEmployeePanel && reviewRuleGroupData.mode === 'EDIT' && this.sharedService.groupType === this.getSharedConstant.manageMasterGroups.groupTypeMGP"
               [label]="getSharedConstant[businessUnit].employeeOrParticipant" [editable]="showActionItems && !sharedService.showHistoricalView.value"
               (editPanel)="goToPreviousStep('../step2')">
  <ems-table-record-count [count]="" [showRecords]="clientList && clientList.length && clientList.length >  getSharedConstant.defaultTableRecords" (emitter)="dtt.reset();receiveDataFromChild($event)" [selectedCount]="" [empIds]=""
                          [showHeaderIcons]="false" [showExportBtn]="!sharedService.deletedMastGrp && revertDisable && isStep1DetailsUnchanged" (exportClicked)="exportMasterGroup()"></ems-table-record-count>

  <p-table #dtt [value]="clientList" [columns]="cols" [rows]="noOfRecords" [paginator]="(!isEditMode && clientList && clientList.length && clientList.length >  getSharedConstant.defaultTableRecords) ? true : false"
           [totalRecords]="clientList && clientList.length" class="common-data-table">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col" *ngFor="let col of columns"><span [innerHTML]="col.header"></span></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length + 1" class="sdps-text-center sdps-font-weight-bold"
              [innerHTML]="getConstant.rulesConstant.autoComplete.noRecords"></td>
        </tr>
      </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns">
          <span>{{rowData[col.field]}}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-paginator #p *ngIf="isEditMode" [alwaysShow]="(isEditMode && totalRecords && totalRecords >  getSharedConstant.defaultTableRecords) ? true : false" [rows]="pageObject.pageSize" [totalRecords]="totalRecords"
               (onPageChange)="paginate($event)" class="common-pagination"></p-paginator>
</ems-accordion>

<!-- Display ngOMS Status groupInfo -->
<ems-accordion *ngIf="showNgOmsSyncPanel" label={{getSharedConstant.ngOMS.groupInfo}}>
      <div class="sdps-grid-container sdps-wrap">
        <div class="sdps-row">
          <div class="col-3">
            <div class="sdps-p-vertical_small">
              @if(businessUnit === 'RBS'){
              <strong>{{getSharedConstant.ngOMS.planId}}</strong>}
              @else
              {<strong>{{getSharedConstant.ngOMS.groupId}}</strong>}
            </div>
            <div class="sdps-grid-container sdps-m-around_none">
              {{reviewRuleGroupData?.ngOmsGroupInfo?.groupId}}
            </div>
          </div>
          <div class="col-3">
            <div class="sdps-p-vertical_small">
              <strong>{{getSharedConstant.ngOMS.lastSyncStatus}}</strong>
            </div>
            <div class="sdps-grid-container sdps-m-around_none">
              {{reviewRuleGroupData?.ngOmsGroupInfo?.lastSyncStatus?.toUpperCase()}}
            </div>
          </div>
        </div>
        <div class="sdps-row">
          <div class="col-3">
            <div class="sdps-p-vertical_small">
              <strong>{{getSharedConstant.ngOMS.syncStartDate}}</strong>
            </div>
            <div class="sdps-grid-container sdps-m-around_none">
              {{reviewRuleGroupData?.ngOmsGroupInfo?.syncStartDate}}
            </div>
          </div>
          <div class="col-3">
            <div class="sdps-p-vertical_small">
              <strong>{{getSharedConstant.ngOMS.lastSyncDate}}</strong>
            </div>
            <div class="sdps-grid-container sdps-m-around_none">
              {{reviewRuleGroupData?.ngOmsGroupInfo?.lastSyncDate}}
            </div>
          </div>
        </div>
        <div class="sdps-row">
          <div class="col-3">
            <div class="sdps-p-vertical_small">
              <strong>{{getSharedConstant.ngOMS.reqCorrelationId}}</strong>
            </div>
            <div class="sdps-grid-container sdps-m-around_none">
              {{reviewRuleGroupData?.ngOmsGroupInfo?.reqCorrelationId}}
            </div>
          </div>
        </div>
      </div>
</ems-accordion>

<ems-step-wizard-buttons
  [disableBtn]="reviewEmpGrpRuleForm?(reviewEmpGrpRuleForm.invalid || groupNameExists || disableSaveBtnForOBP || (reviewEmpGrpRuleForm.get('groupName').value && reviewEmpGrpRuleForm.get('groupName').value.trim() ==='')):''"
  [showCancelBtn]= "showActionItems && !sharedService.showHistoricalView.value" (closeBtn)="cancelGroup()" [showRevertBtn]="showActionItems && !sharedService.showHistoricalView.value" (save)="saveGroup()"
  [revertDisable]="revertDisable" (revert)="revertChanges()" [showSaveBtn]="showActionItems && !sharedService.showHistoricalView.value"
  [showCloseBtn]="!showActionItems || sharedService.showHistoricalView.value" [showPreviousBtn]="showActionItems && !sharedService.showHistoricalView.value" (goToPrevious)="goToPreviousStep('../step2')"
  [ngomsSyncStatusInfoButtons]="(ngOMSForceSync || downLoadNGOMSRule)" [ngOMSForceSync]="ngOMSForceSync && !sharedService.showHistoricalView.value"
  [downLoadNGOMSRule]="downLoadNGOMSRule  && !sharedService.showHistoricalView.value" [forceSyncDisableBtn]="forceSyncDisableBtn"
  [downloadDisableBtn]="downloadDisableBtn" [ngOmsDownloadBtnLabel]="ngOmsDownloadBtnLabel"
  (downloadNgomsRuleAndForceSyncUp)="downloadNgomsRuleAndForceSyncUp($event)"></ems-step-wizard-buttons>